<template>
  <div :class="classes">
    <pt-page-title title="积分商品详情"></pt-page-title>
    <goods-divide :goodsData="goodsData" :pointsGoodsQuota="pointsGoodsQuota"></goods-divide>
    <goods-message :goodsData="goodsData" :mallGoods="mallGoods"></goods-message>
    <pt-sub-title title="发货形式"></pt-sub-title>
    <table>
      <pt-form-list-item label="是否发货：">{{goodsData.shipping_mode }}</pt-form-list-item>
    </table>
    <other-settings :goodsData="goodsData" ></other-settings>
  </div>
</template>

<script>
// 组件class前缀
import goodsDivide from './goods-divide'
import goodsMessage from './goods-message'
import otherSettings from './other-settings'
// import goodsDetail from './goods-detail.json'
const prefixCls = 'pt-integral-goods-detail'
export default {
  name: 'pt-integral-goods-detail',
  components: {
    goodsDivide,
    goodsMessage,
    otherSettings
  },
  props: {
    goodsDetail: {
      type: Object,
      default: Object
    },
    mallGoods: Object
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    goodsData () {
      return this.goodsDetail.goodsData || {}
    },
    pointsGoodsQuota () {
      return this.goodsDetail.pointsGoodsQuota_show
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
</style>
